<template>
    <div>
      <Head title="Chat Settings" />
      <h1 class="mb-8 text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/chat-settings">Chat Settings</Link>
      </h1>
      <div class="flex flex-row">
        <div class="pb-8 pr-6 w-full lg:w-1/2 bg-white rounded-md shadow overflow-hidden mr-5">
          <form @submit.prevent="store">
            <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                  <select-input v-model="form.model" :error="form.errors.model"  class="pb-8 pr-6 w-full lg:w-1/2" label="Model">
                      <option :value="name" v-for="name in modelTypes" :key="name">{{ name }}</option>
                  </select-input>
                <text-input v-model="form.temperature" :error="form.errors.temperature" class="pb-8 pr-6 w-full lg:w-1/2" label="Temperature" />
                <text-input v-model="form.max_tokens" :error="form.errors.max_tokens" class="pb-8 pr-6 w-full lg:w-1/2" label="Max tokens" />
                <text-input v-model="form.top_p" :error="form.errors.top_p" class="pb-8 pr-6 w-full lg:w-1/2" label="Top P" />
                <text-input v-model="form.frequency_penalty" :error="form.errors.frequency_penalty" class="pb-8 pr-6 w-full lg:w-1/2" label="Frequency penalty" />
                <text-input v-model="form.presence_penalty" :error="form.errors.presence_penalty" class="pb-8 pr-6 w-full lg:w-1/2" label="Presence penalty" />
                <text-input v-model="form.max_sentences" :error="form.errors.max_sentences" class="pb-8 pr-6 w-full lg:w-1/2" label="Max sentences" />
                <text-input v-model="form.response_odds" :error="form.errors.response_odds" class="pb-8 pr-6 w-full lg:w-1/2" label="Response odds (percentage)" />
                <text-input v-model="form.response_time_from" :error="form.errors.response_time_from" class="pb-8 pr-6 w-full lg:w-1/2" label="Response time delay from" />
                <text-input v-model="form.response_time_to" :error="form.errors.response_time_to" class="pb-8 pr-6 w-full lg:w-1/2" label="to (in seconds)" />

                <p class="uppercase pb-4 mb-4 w-full border-b ">Settings for testing</p>

                <select-input v-model="chatbox.form.locale" class="pb-8 pr-6 w-full" label="Language">
                      <option value="en">EN</option>
                      <option value="de">DE</option>
                  </select-input>

                <select-input v-model="chatbox.prompt" class="pb-8 pr-6 w-full" label="Prompt (For testing on the right panel)">
                    <option :value="prompt.id" v-for="prompt in promptOptions" :key="prompt.id">{{ prompt.name }}</option>
                </select-input>
            </div>
            <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
              <loading-button :loading="form.processing" class="btn-indigo" type="submit">Save</loading-button>
            </div>
          </form>
        </div>

        <div class="pb-8 pr-6 w-full lg:w-1/2 bg-white rounded-md shadow overflow-hidden">
          <form @submit.prevent="send">
            <div class="flex flex-wrap -mb-8 -mr-6 p-8">

                <div class="flex-1 justify-between flex flex-col h-screen">

                  <div id="messages" class="flex flex-col space-y-4 p-3 overflow-y-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch">
                    <Message v-for="(row, index) in messages" :key="'message'+index" :message="row"></Message>
                  </div>

                  <div class="border-t-2 border-gray-200 px-4 pt-4 mb-2 sm:mb-0">
                    <div class="relative flex">
                      <input type="text" v-model="chatbox.form.message" placeholder="Write your message!" class="w-full focus:outline-none focus:placeholder-gray-400 text-gray-600 placeholder-gray-600 px-5 bg-gray-200 rounded-md py-3">
                      <div class="absolute right-0 items-center inset-y-0 hidden sm:flex">
                        <loading-button :loading="chatbox.form.processing" class="btn-indigo" type="submit">Submit</loading-button>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </form>
        </div>
      </div>

    </div>
  </template>

  <script>
  import { Head, Link } from '@inertiajs/vue3'
  import Layout from '@/Shared/Layout'
  import FileInput from '@/Shared/FileInput'
  import TextInput from '@/Shared/TextInput'
  import SelectInput from '@/Shared/SelectInput'
  import LoadingButton from '@/Shared/LoadingButton'
  import TextareaInput from "@/Shared/TextareaInput";
  import Message from "./Message";
  import axios from 'axios'

  export default {
    components: {
      FileInput,
      Head,
      Link,
      LoadingButton,
      SelectInput,
      TextInput,
      TextareaInput,
      Message
    },
    layout: Layout,
    remember: 'form',
    props: {
        data: Object,
        prompts: Array
    },
    data() {
      return {
        models: [
            'gpt-3.5-turbo-instruct',
            'text-davinci-003',
            'text-curie-001',
            'text-babbage-001',
            'text-ada-001',
            'text-davinci-001',
            'davinci',
            // 'curie',
            // 'babbage',
            // 'ada',
            'gpt-4o',
            'gpt-4-turbo',
            'gpt-4',
            'gpt-3.5-turbo',
            'gpt-3.5-turbo-0125'
        ],
        form: this.$inertia.form({
            model: this.data.model ?? 'text-davinci-003',
            temperature: this.data.temperature ?? 0.5,
            max_tokens: this.data.max_tokens ?? 60,
            top_p: this.data.top_p ?? 1.0,
            frequency_penalty: this.data.frequency_penalty ?? 0.5,
            presence_penalty: this.data.presence_penalty ?? 0.0,
            max_sentences: this.data.max_sentences ?? 4,
            prompt: this.data.prompt ?? 'I want you to act like a girl who looks for a boyfriend. Do not write all about yourself and the conservation at once. Answer the questions one by one. You are 30 years old and live near Berlin in a smaller village. You have big boobs, your pussy is shaved and your favourite position is doggy.',
            response_odds: this.data.response_odds ?? 30,
            response_time_from: this.data.response_time ? this.data.response_time[0] : 5,
            response_time_to: this.data.response_time ? this.data.response_time[1] : 15,
        }),
        chatbox: {
          processing: false,
          prompt: '',
          form: this.$inertia.form({
            message: '',
            locale: 'de'
          })
        },
        messages: [],
        openedConversation: null
      }
    },
    computed: {
      modelTypes() {
        const values = this.models;

        values.sort();

        return values;
      },
      promptOptions() {
        let result = [];

        if(this.prompts) {
          result = this.prompts.filter(prompt => prompt.locale == this.chatbox.form.locale);
        }

        return result;
      }
    },
    created() {
      if(this.prompts) {
        this.chatbox.prompt = this.prompts[0]?.id
      }
    },
    methods: {
      store() {
        this.form.post('/chat-settings')
      },
      send() {
        this.addMessage(this.chatbox.form.message, false);
        this.chatbox.form.message = '';

        axios.post('/chat-ai-test', {
          "messages": this.messages,
          "prompt": this.chatbox.prompt
        }).then(result => {
          this.addMessage(result.data.message, true);
        });
      },
      addMessage(message, isAi) {
        this.messages.push({
          text: message,
          is_customer_message: isAi
        });
      }
    },
  }
  </script>
